import { BookingsDto } from '../../types';
import BookingApi from '@/features/Bookings/services';

const bookingApi = new BookingApi();

export const getBookings = async (): Promise<BookingsDto | undefined> => {
    return await bookingApi.getBookings();
};

export const cancelBooking = async (bookingId: string): Promise<void> => {
    await bookingApi.cancelBooking(bookingId);
};
